import tripsReducer from './tripsReducer'
import settingsReducer from './settingsReducer'
import uiReducer from './uiReducer'

import * as tripsSelector from './tripsSelector'
import * as settingsSelector from './settingsSelector'
import * as uiSelector from './uiSelector'

export default {
  trips: tripsReducer,
  settings: settingsReducer,
  ui: uiReducer,
}

// ** APP MODE **
// export const appMode = () => 'default-trip-only'
export const appMode = () => 'default-trip-only'

// ****************
// *** settings ***
// ****************

export const videoResolutionDisplay = state => settingsSelector.videoResolutionDisplay(state.settings)

// *************
// *** trips ***
// *************

export const selectedTripId = state => tripsSelector.selectedTripId(state.trips)
export const tripDataById = (state, id) =>
  tripsSelector.tripDataById(state.trips, id)
export const existingTripIds = state =>
  tripsSelector.existingTripIds(state.trips)
export const selectedTripData = state =>
  tripsSelector.selectedTripData(state.trips)
export const selectedTripMedia = state =>
  tripsSelector.selectedTripMedia(state.trips)

export const currentEventId = state => tripsSelector.currentEventId(state.trips)

export const addingTrip = state => tripsSelector.addingTrip(state.trips)
export const editingTrip = state => tripsSelector.editingTrip(state.trips)
export const listingMode = state =>
  tripsSelector.listingMode(state.trips)

export const selectedEventId = state =>
  tripsSelector.selectedEventId(state.trips)
export const selectedEventData = state =>
  tripsSelector.selectedEventData(state.trips)
export const selectedEventIndex = state =>
  tripsSelector.selectedEventIndex(state.trips)
export const selectedEventNextEvent = state =>
  tripsSelector.selectedEventNextEvent(state.trips)
export const selectedEventNextEventId = state =>
  tripsSelector.selectedEventNextEventId(state.trips)
export const selectedEventPreviousEventId = state =>
  tripsSelector.selectedEventPreviousEventId(state.trips)
export const selectedEventPreviousEvent = state =>
  tripsSelector.selectedEventPreviousEvent(state.trips)
export const selectedEventInfoDisplayed = state =>
  tripsSelector.selectedEventInfoDisplayed(state.trips)
export const selectedEventInfoDayMediaDisplayed = state =>
  tripsSelector.selectedEventInfoDayMediaDisplayed(state.trips)
export const selectedEventMediaId = state =>
  tripsSelector.selectedEventMediaId(state.trips)
export const selectedEventMediaType = state =>
  tripsSelector.selectedEventMediaType(state.trips)

export const tripsList = state => tripsSelector.tripsList(state.trips)


// ****************
// *** UI State ***
// ****************

export const isMagicDrawerOpen = state =>
  uiSelector.isMagicDrawerOpen(state.ui)



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js